export class MoovStepCustomerParametersDTO{
    public id!: number;
    public moovStepId!: number;
    public customerId!: number;
    public parameterOptionId!: number;
    public parameters!: string;

}